import BellSVG from "@aviary/illustrations/bell.svg";
import OrderBoxSVG from "@aviary/illustrations/client-orders.svg";
import EmptyBottleSVG from "@aviary/illustrations/empty-bottle.svg";
import EnvelopeSVG from "@aviary/illustrations/envelope.svg";
import EmptyOrderBoxSVG from "@aviary/illustrations/favorite-products.svg";
import LighthouseSVG from "@aviary/illustrations/lighthouse.svg";
import MoneySVG from "@aviary/illustrations/money.svg";
import MountainsSVG from "@aviary/illustrations/mountains.svg";
import PlantSVG from "@aviary/illustrations/no-swaps.svg";
import PaperPlaneSVG from "@aviary/illustrations/paper-plane.svg";
import SwapProductsSVG from "@aviary/illustrations/past-swaps.svg";
import PeopleSVG from "@aviary/illustrations/people.svg";
import ProductCardSVG from "@aviary/illustrations/prescription-card.svg";
import DocumentSVG from "@aviary/illustrations/prescription-doc.svg";
import LaptopSVG from "@aviary/illustrations/prescription-laptop.svg";
import RocketSVG from "@aviary/illustrations/rocket.svg";
import HandSelectSVG from "@aviary/illustrations/select.svg";
import IdCardWithSupplementsSVG from "@aviary/illustrations/staff.svg";
import SupplementsSVG from "@aviary/illustrations/supplements.svg";
import { AVIARY_ILLUSTRATIONS, type AviaryIllustration } from "@aviary/types";

import * as styles from "./Illustration.styles";

interface Props {
  /**
   * An Aviary Illustration
   */
  illustration: AviaryIllustration;
  /**
   * Option to change width and height (in rem)
   */
  heightAndWidth?: number;
  /**
   * Option to change to mobile size
   */
  isMobile?: boolean;
}

const Illustration = ({ illustration, heightAndWidth, isMobile, ...rest }: Props) => {
  const svgStyles = [
    styles.size.desktop,
    isMobile && styles.size.mobile,
    heightAndWidth && styles.heightAndWidth(heightAndWidth),
  ];

  const renderSvg = () => {
    switch (illustration) {
      case AVIARY_ILLUSTRATIONS.bell:
        return (
          <BellSVG aria-hidden data-testid={AVIARY_ILLUSTRATIONS.bell} css={svgStyles} {...rest} />
        );
      case AVIARY_ILLUSTRATIONS.document:
        return (
          <DocumentSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.document}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.emptyBottle:
        return (
          <EmptyBottleSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.emptyBottle}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.emptyOrderBox:
        return (
          <EmptyOrderBoxSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.emptyOrderBox}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.envelope:
        return (
          <EnvelopeSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.envelope}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.handSelect:
        return (
          <HandSelectSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.handSelect}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.idCardAndSupplements:
        return (
          <IdCardWithSupplementsSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.idCardAndSupplements}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.laptop:
        return (
          <LaptopSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.laptop}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.lighthouse:
        return (
          <LighthouseSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.lighthouse}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.money:
        return (
          <MoneySVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.money}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.mountains:
        return (
          <MountainsSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.mountains}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.orderBox:
        return (
          <OrderBoxSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.orderBox}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.paperPlane:
        return (
          <PaperPlaneSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.paperPlane}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.people:
        return (
          <PeopleSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.people}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.plant:
        return (
          <PlantSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.plant}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.productCard:
        return (
          <ProductCardSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.productCard}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.rocket:
        return (
          <RocketSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.rocket}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.supplements:
        return (
          <SupplementsSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.supplements}
            css={svgStyles}
            {...rest}
          />
        );
      case AVIARY_ILLUSTRATIONS.swapProducts:
        return (
          <SwapProductsSVG
            aria-hidden
            data-testid={AVIARY_ILLUSTRATIONS.swapProducts}
            css={svgStyles}
            {...rest}
          />
        );
    }
  };

  return <>{renderSvg()}</>;
};

export { Illustration };
